import React from 'react';
import { Link } from 'react-router-dom';
import { Logo } from './Logo';

const colTitle =
  'text-[13px] font-semibold uppercase tracking-[0.08em] text-[#65676B]';
const linkClass = 'text-[15px] text-[#1C1E21] hover:text-[#0064E0] transition-colors';

export function Footer() {
  return (
    <footer className="border-t border-[#E4E6EB] bg-[#F0F2F5]">
      <div className="mx-auto max-w-7xl px-5 py-16 md:px-8">
        <Logo size="md" />
        <div className="mt-12 grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4 lg:gap-8">
          <div>
            <p className={colTitle}>Company</p>
            <ul className="mt-4 space-y-3">
              <li>
                <Link to="/about" className={linkClass}>
                  About
                </Link>
              </li>
              <li>
                <Link to="/products" className={linkClass}>
                  Products
                </Link>
              </li>
              <li>
                <Link to="/services" className={linkClass}>
                  Services
                </Link>
              </li>
              <li>
                <Link to="/blog" className={linkClass}>
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/contact" className={linkClass}>
                  Contact
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <p className={colTitle}>Products</p>
            <ul className="mt-4 space-y-3">
              <li>
                <a
                  href="https://shieldsme.lognsec.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={linkClass}
                >
                  ShieldSME
                </a>
              </li>
              <li>
                <a
                  href="https://www.koklonya.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={linkClass}
                >
                  Koklonya
                </a>
              </li>
              <li>
                <Link to="/products" className={linkClass}>
                  All products
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <p className={colTitle}>Legal</p>
            <ul className="mt-4 space-y-3">
              <li>
                <Link to="/privacy" className={linkClass}>
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className={linkClass}>
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <p className={colTitle}>Connect</p>
            <ul className="mt-4 space-y-3">
              <li>
                <a
                  href="https://www.linkedin.com/company/lognsec"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={linkClass}
                >
                  LinkedIn
                </a>
              </li>
              <li>
                <a
                  href="https://github.com/princeseg"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={linkClass}
                >
                  GitHub
                </a>
              </li>
              <li>
                <a
                  href="https://x.com/lognsec"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={linkClass}
                >
                  Twitter/X
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-14 border-t border-[#E4E6EB] pt-8 text-[13px] text-[#65676B]">
          © 2025 logNsec. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
